/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Knowit
// License: CC-BY 4.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const SearchMedia = (props: Props): JSX.Element => (
  <Icon viewBox="0 0 52 40" {...props}>
    <path d="M51.2 0H.8a.9.9 0 0 0-.8.8v38.4a.9.9 0 0 0 .8.8h50.4a.9.9 0 0 0 .8-.8V.8a.9.9 0 0 0-.8-.8m-.7 1.5v17.2L38.6 9.8l-5.8 4.9a11 11 0 0 0-2.4-2.8 10 10 0 0 0-5.7-2.1 10.1 10.1 0 0 0-10.8 9.5v.3l-5.2-3.2-7.2 6.1v-21ZM32.6 25.4l7.2 5.4c.3.3.4.6.2.9l-.6.7a.5.5 0 0 1-.4.2h-.4l-7.3-5.4a7 7 0 0 0 1.3-1.8m-9.1 3a8.5 8.5 0 1 1 9-8 8.5 8.5 0 0 1-9 8m-22 10.1v-14l7.3-6.2 5.2 3.1a10.2 10.2 0 0 0 3.7 6.5 10.2 10.2 0 0 0 12.3.3l7.5 5.7a2.5 2.5 0 0 0 1.7.4 2.1 2.1 0 0 0 1.6-.8l.5-.7a2.3 2.3 0 0 0-.4-3.3l-7.4-5.7a9 9 0 0 0 .7-3.2 11 11 0 0 0-.7-4.5l5.2-4.4 11.8 8.8v18Z" />
  </Icon>
);
